export default "__VITE_ASSET__D9RRP_oV__"